import React, {useEffect } from "react";
import {useNavigate } from "react-router-dom";
import { Joyride } from 'react-joyride';
import { getJoyrideScrollOffset } from 'utils/joyrideConfig';
import { useHomeTour } from 'hooks/useHomeTour';
import { appointment } from "@solimat/solimat-web-endpoint";
import useDecode from "../../../hooks/useDecode";
import usePageTitle from 'hooks/usePageTitle';
// styles
import "./Home.scss";
import { checkIsImpersonation } from "hooks/useSetToken";
import MobileApps from "components/blocks/MobileApps/MobileApps";
import { useGeneralManagementState } from "../../pages/GeneralManagement/generalManagementState";
import NextAppointmentNew from "components/blocks/NextAppointment/NextAppointmentNew";
import InfoRoyalDecreeFormNew from 'components/blocks/HomeAlerts/InfoRoyalDecreeFormNew';
import QuickActions from 'components/blocks/QuickActions/QuickActions';
import PublicMutua from 'components/blocks/PublicMutua/PublicMutua';
import InfoNew from 'components/blocks/InfoNew/InfoNew';
import MovilAppNew from "components/blocks/MovilAppNew/MovilAppNew";


const BASE_URL = import.meta.env.VITE_REACT_APP_CITAS_PATH || "";
const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_CITAS_KEY || "";
const apiAppointment = new appointment.AppointmeService(
  BASE_URL,
  FUNCTIONS_KEY
);



<MobileApps></MobileApps>

const Home: React.FC = () => {
  const navigate = useNavigate();
  usePageTitle('Inicio');
  const tokenResponse = useDecode("token");
  const userId = tokenResponse && tokenResponse.extension_id;
  const isImpersonation = tokenResponse && checkIsImpersonation(tokenResponse);
  const { dispatch } = useGeneralManagementState();
  const { run, tourKey, steps, handleCallback, startTour } = useHomeTour();


  const hideSurveyTemporarily = () => {
    dispatch({ type: "SHOW_SURVEY", payload: { show: false, id: '' } });
    setTimeout(() => {
      dispatch({ type: "SHOW_SURVEY", payload: { show: true, id: '' } });
    }, 2000);
  };


  useEffect(() => {
    hideSurveyTemporarily();
    localStorage.removeItem('selectedProvince');
    localStorage.removeItem('selectedProvinceName');
    localStorage.removeItem('selectedCenters');
  }, [])

  useEffect(() => {
    const handler = () => startTour();
    window.addEventListener('solimat:startHomeTour', handler);
    return () => window.removeEventListener('solimat:startHomeTour', handler);
  }, [startTour]);

  return (
    <div className="home">
      <h1 className="sr-only">Inicio — Portal de Pacientes SOLIMAT</h1>
      <Joyride
        key={tourKey}
        steps={steps}
        run={run}
        onEvent={handleCallback}
        continuous
        scrollToFirstStep
        locale={{
          back: 'Anterior',
          close: 'Cerrar',
          last: 'Finalizar',
          next: 'Siguiente',
          nextWithProgress: 'Siguiente ({current} de {total})',
          open: 'Iniciar tour de ayuda',
          skip: 'Omitir tour',
        }}
        options={{
          primaryColor: '#0F1F3D',
          zIndex: 10000,
          overlayColor: 'rgba(15, 47, 73, 0.45)',
          showProgress: true,
          buttons: ['back', 'skip', 'close', 'primary'],
          scrollOffset: getJoyrideScrollOffset(),
        } as any}
        styles={{
          beaconInner: { backgroundColor: '#F97316' },
          beaconOuter: { borderColor: '#F97316', backgroundColor: 'rgba(249, 115, 22, 0.2)' },
          tooltip: { borderRadius: 8, fontSize: 14 },
          tooltipTitle: { fontSize: 15, fontWeight: 700, textAlign: 'left' },
          tooltipContent: { textAlign: 'left' },
        }}
      />
      <NextAppointmentNew
        userId={userId ?? undefined}
        userName={tokenResponse?.extension_first_name ?? 'Paciente'}
      />
   <InfoRoyalDecreeFormNew onNav={(section) => navigate(`/${section}`)}></InfoRoyalDecreeFormNew>
      <QuickActions />
      <PublicMutua />
      <InfoNew />
      <MovilAppNew />
    </div>
  );
};

export default Home;
